import React from 'react';
import { useThemeMode } from '../../design-system/theme';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import ChallengeClarityPaint from '../challenges/ChallengeClarityPaint';
import { EducationDesignPreview } from '../education/EducationDesignExperiment';
import CoursePage from './CoursePage';
import '../education/EducationControlRoom.css';
import './CoursePageControlRoom.css';
import './CoursePageClarity.css';
import '../challenges/ChallengePageClarity.css';

export const COURSE_CLARITY_REVIEW_SLUG = 'ai-trading-bootcamp';

/**
 * Review route: /courses-clarity and /courses-clarity/ai-trading-bootcamp.
 * Mounts the live PostHog test (Clarity) CoursePage without enrollment.
 * Does not evaluate ai_trading_bootcamp_control_vs_clarity_2026_08_31.
 */
export default function CourseClarityReview(): React.ReactElement {
  const [theme] = useThemeMode();
  const { slug: paramSlug } = useParams<{ slug?: string }>();
  const location = useLocation();
  const pathSlug = location.pathname.match(/^\/courses-clarity\/([^/]+)/)?.[1];
  const slug = paramSlug || pathSlug;
  const resolvedSlug = slug || COURSE_CLARITY_REVIEW_SLUG;

  if (!slug) {
    return (
      <Navigate to={`/courses-clarity/${resolvedSlug}${location.search}${location.hash}`} replace />
    );
  }

  return (
    <div
      className="course-clarity-review education-design-experiment education-design-experiment--control-room education-design-experiment--clarity"
      data-testid="course-clarity-review"
      data-education-design-variant="clarity"
      data-education-theme={theme}
      data-education-theme-source="review"
      data-experiment-active="false"
    >
      <EducationDesignPreview variant="clarity">
        <CoursePage />
      </EducationDesignPreview>
      <ChallengeClarityPaint rootSelector='[data-testid="course-clarity-review"]' />
    </div>
  );
}
